(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-tabs-2-block"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (!root || root.dataset.blProductTabsReady === 'true') return;

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      const activate = (nextTab, moveFocus = false) => {
        const target = nextTab.dataset.tabTarget;

        tabs.forEach((tab) => {
          const selected = tab === nextTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          const selected = panel.dataset.tabPanel === target;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });

        nextTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        if (moveFocus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex !== index) {
            event.preventDefault();
            activate(tabs[nextIndex], true);
          }
        });
      });

      root.dataset.blProductTabsReady = 'true';
    };

    const initializeAll = (scope) => {
      if (scope.matches && scope.matches('[data-bl-product-tabs]')) initialize(scope);
      scope.querySelectorAll('[data-bl-product-tabs]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
